module.exports = __webpack_public_path__ + "img/QQ.b6432515.png";